var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-3{fill:#231f20}"), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 0,
    y: 0,
    width: 16,
    height: 16,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mask-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-1",
    fill: "#fff",
    d: "M0 0h16v16H0V0z"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask)",
    id: "Fill-1-Clipped"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    className: "cls-3",
    d: "M4.7.05a5.85 5.85 0 0 0-1.94.37A4 4 0 0 0 .42 2.76 5.85 5.85 0 0 0 .05 4.7C0 5.55 0 5.83 0 8s0 2.45.05 3.3a5.85 5.85 0 0 0 .37 1.94 4 4 0 0 0 2.34 2.34A5.85 5.85 0 0 0 4.7 16H8c2.17 0 2.45 0 3.3-.05a5.85 5.85 0 0 0 1.94-.37 4 4 0 0 0 2.34-2.34A5.85 5.85 0 0 0 16 11.3c0-.85.05-1.13.05-3.3S16 5.55 16 4.7a5.85 5.85 0 0 0-.37-1.94A4 4 0 0 0 13.24.42 5.85 5.85 0 0 0 11.3.05C10.45 0 10.17 0 8 0S5.55 0 4.7.05zm6.53 1.44a4.33 4.33 0 0 1 1.49.27 2.67 2.67 0 0 1 1.52 1.52 4.33 4.33 0 0 1 .27 1.49c0 .84.05 1.09.05 3.23s0 2.39-.05 3.23a4.33 4.33 0 0 1-.27 1.49 2.67 2.67 0 0 1-1.52 1.52 4.33 4.33 0 0 1-1.49.27c-.84 0-1.09.05-3.23.05s-2.39 0-3.23-.05a4.33 4.33 0 0 1-1.49-.27 2.67 2.67 0 0 1-1.52-1.52 4.33 4.33 0 0 1-.27-1.49c0-.84-.05-1.09-.05-3.23s0-2.39.05-3.23a4.33 4.33 0 0 1 .27-1.49 2.67 2.67 0 0 1 1.52-1.52 4.33 4.33 0 0 1 1.49-.27c.84 0 1.09-.05 3.23-.05s2.39.01 3.23.05z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Fill-4",
    className: "cls-3",
    d: "M8 10.67A2.67 2.67 0 1 1 10.67 8 2.68 2.68 0 0 1 8 10.67m0-6.78A4.11 4.11 0 1 0 12.11 8 4.11 4.11 0 0 0 8 3.89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-6",
    className: "cls-3",
    d: "M13.23 3.73a1 1 0 1 1-1-1 1 1 0 0 1 1 1"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.9c2f6b1e20461d38ae1cd8464c343728.svg";
export { ForwardRef as ReactComponent };